export function tableCellNullValueParser(value: any, mask?: any) {
  if (!value) return "-";

  return mask ? mask(value) : value;
}
